import React from "react";
import { getCriteriaKeys, sortChoices } from "./choices";
import { CriterionChoices } from "./CriterionChoices";
import useSelectedChoices from "./useSelectedChoices";
import { criteriaElementsType, notDeletableType } from "../../../common/types/search/search";

interface SelectedChoicesProps {
	criteria?: criteriaElementsType;
	groupCriteria?: object;
	notDeletable?: notDeletableType;
}

export function SelectedChoices({
	groupCriteria,
	criteria,
	notDeletable,
}: SelectedChoicesProps) {
	const { choices, choicesEmpty } = useSelectedChoices({
		ignoreContent: true,
	});
	let selectedChoices = sortChoices(choices, criteria);

	if (choicesEmpty) {
		return null;
	}

	if (groupCriteria) {
		const criteria = getCriteriaKeys(groupCriteria);
		choices.filter((v: string, key: string) => criteria.includes(key));
		selectedChoices = sortChoices(choices).filter(
			(v: string, key: string) => criteria.includes(key),
		);
	}

	if (selectedChoices.size === 0) {
		return null;
	}

	const labels = selectedChoices.keySeq().map((key: string) => {
		return (
			<CriterionChoices
				key={key}
				criterionKey={key}
				notDeletable={notDeletable}
			/>
		);
	});

	return <ul className="search-selected-choices">{labels}</ul>;
}
